import { Loading } from '@softwareimaging/react';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Meta } from '../../lib/meta';
import { useSignOut } from '../../services/authentication/hooks/auth';

export const SignOut: FC = () => {
  const signOut = useSignOut();
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      await signOut();
      navigate('/');
    })();
  }, [signOut]);

  return (
    <>
      <Meta title="Sign out" />
      <Loading className="h-screen" />
    </>
  );
};
